import React from 'react';
import { ThemeProvider } from '@fluentui/react';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
initializeIcons();

import { Container } from './styled';

export const AppContainer = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <React.StrictMode>
      <ThemeProvider>
        <Container>{children}</Container>
      </ThemeProvider>
    </React.StrictMode>
  );
};
